import React, {Component} from 'react'
import {Button} from 'reactstrap'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {withRouter} from 'react-router-dom'

import UsersTable from "./UserTable";

class Users extends Component {

    state = {
        createUserModalOpen: false,
    }

    render() {

        const {createUserModalOpen} = this.state

        return (
            <div className="d-flex flex-column">
                <div className="d-flex flex-row align-items-center justify-content-end p-3">
                    <Button
                        size="sm"
                        color="success"
                        onClick={() => this.props.history.push('/users/create/')}
                    >
                        <FontAwesomeIcon
                            color="#fff"
                            icon="plus"/>{' '}
                        Add User
                    </Button>
                </div>
                <UsersTable/>

            </div>
        )

    }

}

Users = withRouter(Users)

export default Users